import React, { useEffect, useState,useRef } from "react";
import { Link } from "react-router-dom";
import "../../styles/home/TechlynxHero.css";
import Slide1 from "../../assets/slide1.png";
import Slide2 from "../../assets/slide2.png";
import Slide3 from "../../assets/slide3.png";
import Slide4 from "../../assets/slide4.png";
const slides = [
  {
    id: 1,
    tag: "DIGITAL TRANSFORMATION",
    title: "Build Smarter",
    highlight: "Scale Faster",
    description:
      "Transform your business with modern software solutions, cloud technologies, AI, and intelligent digital experiences.",
    primaryButton: "Explore Solutions",
    primaryLink: "/services",
    secondaryButton: "Talk to Us",
    secondaryLink: "/contact",
    image: Slide1,
    overlayRgb: "218, 238, 242",
  },

  {
    id: 2,
    tag: "ARTIFICIAL INTELLIGENCE",
    title: "Turn AI Into",
    highlight: "Business Advantage",
    description:
      "Harness artificial intelligence, automation, and generative AI to create smarter workflows and better business decisions.",
    primaryButton: "Explore AI",
    primaryLink: "/services/ai-machine-learning",
    secondaryButton: "Learn More",
    secondaryLink: "/services/ai-work-film",
    image: Slide2,
    overlayRgb: "214, 235, 231",
  },

  {
    id: 3,
    tag: "CLOUD & SOFTWARE ENGINEERING",
    title: "Engineering the",
    highlight: "Digital Future",
    description:
      "Build scalable applications, APIs, cloud platforms, and enterprise software designed for performance and long-term growth.",
    primaryButton: "Our Services",
    primaryLink: "/services/software-web-engineering",
    secondaryButton: "View Projects",
    secondaryLink: "/case-studies",
    image: Slide3,
    overlayRgb: "218, 231, 240",
  },

  {
    id: 4,
    tag: "CYBER SECURITY & ENTERPRISE",
    title: "Secure",
    highlight: "Connected Ready",
    description:
      "Strengthen your digital infrastructure with secure software, Cyber Security solutions, and reliable enterprise technology.",
    primaryButton: "Cyber Security",
    primaryLink: "/services/cyber-security",
    secondaryButton: "Contact Us",
    secondaryLink: "/contact",
    image: Slide4,
    overlayRgb: "224, 236, 238",
  }
];

const TechlynxHero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((previous) =>
        previous === slides.length - 1 ? 0 : previous + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((previous) =>
      previous === slides.length - 1 ? 0 : previous + 1
    );
  };

  const previousSlide = () => {
    setCurrentSlide((previous) =>
      previous === 0 ? slides.length - 1 : previous - 1
    );
  };

  return (
    <section className="hero-carousel">

      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${
            index === currentSlide ? "hero-slide-active" : ""
          }`}
          style={{
            backgroundImage: `url(${slide.image})`,
            "--hero-overlay-rgb": slide.overlayRgb,
          }}
        >

          <div className="hero-overlay"></div>

          <div className="hero-glow"></div>

          <div className="hero-content">

            <div className="hero-tag">
              <span className="hero-tag-line"></span>
              {slide.tag}
            </div>

            <h1>
              {slide.title}
              <br />
              <span>{slide.highlight}</span>
            </h1>

            <p>{slide.description}</p>

            <div className="hero-buttons">

              <Link className="hero-primary-btn" to={slide.primaryLink}>
                {slide.primaryButton}
                <span>→</span>
              </Link>

              <Link className="hero-secondary-btn" to={slide.secondaryLink}>
                {slide.secondaryButton}
              </Link>

            </div>

          </div>
          {/*

          <div className="hero-tech-decoration">

            <div className="tech-circle tech-circle-one"></div>

            <div className="tech-circle tech-circle-two"></div>

            <div className="tech-line tech-line-one"></div>

            <div className="tech-line tech-line-two"></div>

            <div className="tech-node tech-node-one"></div>

            <div className="tech-node tech-node-two"></div>

            <div className="tech-node tech-node-three"></div>

          </div> */}

        </div>
      ))}

      {/* Previous */}
      <button
        className="hero-arrow hero-arrow-left"
        onClick={previousSlide}
        aria-label="Previous slide"
      >
        ‹
      </button>

      {/* Next */}
      <button
        className="hero-arrow hero-arrow-right"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        ›
      </button>

      {/* Indicators */}
      <div className="hero-indicators">

        {slides.map((slide, index) => (
          <button
            key={slide.id}
            className={`hero-indicator ${
              index === currentSlide ? "hero-indicator-active" : ""
            }`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          >
            <span></span>
          </button>
        ))}

      </div>

      {/* Counter */}
      <div className="hero-counter">

        <span>
          {String(currentSlide + 1).padStart(2, "0")}
        </span>

        <div className="hero-counter-line"></div>

        <span>
          {String(slides.length).padStart(2, "0")}
        </span>

      </div>

    </section>
  );
};

const NODES = [
  [9, 15, "AI"], [22, 67, "DATA"], [33, 16, "CLOUD"], [43, 79, "DEV"],
  [55, 22, "WEB"], [66, 71, "SEC"], [78, 30, "ML"], [88, 62, "API"],
  [92, 18, "RAG"], [15, 48, "SQL"], [72, 84, "ERP"], [37, 51, "QA"],
];

const BUBBLE_COLORS = [
  "rgba(13, 125, 166, 0.72)",
  "rgba(70, 135, 205, 0.7)",
  "rgba(20, 158, 158, 0.68)",
  "rgba(113, 108, 210, 0.68)",
  "rgba(61, 170, 210, 0.72)",
  "rgba(91, 111, 190, 0.7)",
];

const FLOATING_BUBBLES = Array.from({ length: 28 }, (_, index) => ({
  id: index,
  left: `${Math.floor(Math.random() * 90) + 5}%`,
  size: `${Math.floor(Math.random() * 25) + 8}px`,
  delay: `-${Math.floor(Math.random() * 30)}s`,
  duration: `${Math.floor(Math.random() * 15) + 18}s`,
  drift: `${Math.floor(Math.random() * 111) - 55}px`,
  color: BUBBLE_COLORS[Math.floor(Math.random() * BUBBLE_COLORS.length)],
}));

const MARGIN_FLOWERS = [
  { side: "left", top: "24%", size: 32, delay: "-1s", color: "#48aeca" },
  { side: "left", top: "68%", size: 24, delay: "-3s", color: "#788bd6" },
  { side: "left", top: "46%", size: 19, delay: "-5s", color: "#49b9ad" },
  { side: "right", top: "30%", size: 26, delay: "-2s", color: "#788bd6" },
  { side: "right", top: "70%", size: 34, delay: "-4s", color: "#48aeca" },
  { side: "right", top: "49%", size: 18, delay: "-6s", color: "#49b9ad" },
];

function MarginFlowers() {
  return (
    <div className="tlx-margin-flowers" aria-hidden="true">
      {MARGIN_FLOWERS.map((flower, index) => (
        <span
          key={index}
          className={`tlx-margin-flower is-${flower.side}`}
          style={{
            "--flower-top": flower.top,
            "--flower-size": `${flower.size}px`,
            "--flower-delay": flower.delay,
            "--flower-color": flower.color,
          }}
        >
          {Array.from({ length: 6 }, (_, petal) => (
            <i key={petal} style={{ "--petal-angle": `${petal * 60}deg` }} />
          ))}
          <b />
        </span>
      ))}
    </div>
  );
}

function FloatingBubble({ bubble }) {
  const [isPopped, setIsPopped] = useState(false);
  const popTimer = useRef(null);

  useEffect(() => () => window.clearTimeout(popTimer.current), []);

  const popBubble = () => {
    window.clearTimeout(popTimer.current);
    setIsPopped(true);
    popTimer.current = window.setTimeout(() => setIsPopped(false), 450);
  };

  return (
    <button
      type="button"
      className="tlx-bubble"
      aria-label="Pop floating bubble"
      onClick={popBubble}
      style={{
        "--bubble-left": bubble.left,
        "--bubble-size": bubble.size,
        "--bubble-delay": bubble.delay,
        "--bubble-duration": bubble.duration,
        "--bubble-drift": bubble.drift,
        "--bubble-color": bubble.color,
      }}
    >
      <span className={`tlx-bubble-visual${isPopped ? " is-popped" : ""}`} />
    </button>
  );
}

function FloatingBubbles() {
  return (
    <div className="tlx-floating-bubbles" role="group" aria-label="Interactive floating bubbles">
      {FLOATING_BUBBLES.map((bubble) => <FloatingBubble key={bubble.id} bubble={bubble} />)}
    </div>
  );
}

function usePointerField(ref) {
  useEffect(() => {
    const root = ref.current;
    if (!root || window.matchMedia("(pointer: coarse)").matches) return undefined;

    let raf = 0;
    const target = { x: 0, y: 0, active: false };
    const current = { x: 0, y: 0 };

    const onMove = (event) => {
      const rect = root.getBoundingClientRect();
      target.x = event.clientX - rect.left;
      target.y = event.clientY - rect.top;
      target.active = true;
    };
    const onLeave = () => { target.active = false; };

    const tick = () => {
      current.x += ((target.active ? target.x : root.clientWidth * 0.52) - current.x) * 0.075;
      current.y += ((target.active ? target.y : root.clientHeight * 0.44) - current.y) * 0.075;
      root.style.setProperty("--mx", `${current.x}px`);
      root.style.setProperty("--my", `${current.y}px`);

      root.querySelectorAll("[data-depth]").forEach((el) => {
        const depth = Number(el.dataset.depth || 1);
        const dx = (current.x - root.clientWidth / 2) / root.clientWidth;
        const dy = (current.y - root.clientHeight / 2) / root.clientHeight;
        el.style.transform = `translate3d(${dx * depth * -28}px, ${dy * depth * -20}px, 0)`;
      });
      raf = requestAnimationFrame(tick);
    };

    root.addEventListener("pointermove", onMove);
    root.addEventListener("pointerleave", onLeave);
    raf = requestAnimationFrame(tick);
    return () => {
      root.removeEventListener("pointermove", onMove);
      root.removeEventListener("pointerleave", onLeave);
      cancelAnimationFrame(raf);
    };
  }, [ref]);
}

function HeroNetwork() {
  const ref = useRef(null);
  usePointerField(ref);

  return (
    <div ref={ref} className="tlx-hero-visual" aria-hidden="true">
      <div className="tlx-hero-vignette" />
      <div className="tlx-hero-grid" data-depth="1" />
      <div className="tlx-hero-scan" data-depth="2" />

      <div className="tlx-cursor-aura" />

      <div className="tlx-orbit tlx-orbit-a" data-depth="3" />
      <div className="tlx-orbit tlx-orbit-b" data-depth="2" />
      <div className="tlx-orbit tlx-orbit-c" data-depth="1" />

      <svg className="tlx-connections" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M11 25 L33 16 L55 22 L78 30 L92 18" />
        <path d="M15 48 L37 51 L55 22 L72 84" />
        <path d="M22 67 L37 51 L66 71 L88 62" />
        <path d="M43 79 L66 71 L72 84 L88 62" />
      </svg>

      {NODES.map(([x, y, label], index) => (
        <div
          key={label}
          className={`tlx-node tlx-node-${index}`}
          style={{ left: `${x}%`, top: `${y}%` }}
          data-depth={(index % 3) + 1}
        >
          <span />
          <small>{label}</small>
        </div>
      ))}


      <div className="tlx-core" data-depth="4">
        <div className="tlx-core-ring ring-one" />
        <div className="tlx-core-ring ring-two" />
        <div className="tlx-core-inner">
          <b>Techlynx</b>
          <span>Innovation<br />Pvt. Lmt</span>
        </div>
      </div>

      <div className="tlx-coordinate coord-a">17.492 / 82.231</div>
      <div className="tlx-coordinate coord-b">SYS.ONLINE // 98+</div>
    </div>
  );
}

function RepelWordmark() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root || window.matchMedia("(pointer: coarse)").matches) return undefined;

    const letters = [...root.querySelectorAll("[data-letter]")];
    const pointer = { x: -1000, y: -1000 };
    const offsets = letters.map(() => ({ x: 0, y: 0 }));
    let raf = 0;

    const onPointerMove = (event) => {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
    };

    const animate = () => {
      letters.forEach((letter, index) => {
        const rect = letter.getBoundingClientRect();
        const dx = rect.left + rect.width / 2 - pointer.x;
        const dy = rect.top + rect.height / 2 - pointer.y;
        const distance = Math.hypot(dx, dy);
        const radius = 185;
        let targetX = 0;
        let targetY = 0;

        if (distance < radius && distance > 0) {
          const strength = ((radius - distance) / radius) ** 2;
          targetX = (dx / distance) * strength * 55;
          targetY = (dy / distance) * strength * 40;
        }

        offsets[index].x += (targetX - offsets[index].x) * 0.12;
        offsets[index].y += (targetY - offsets[index].y) * 0.12;
        letter.style.transform =
          `translate3d(${offsets[index].x}px, ${offsets[index].y}px, 0)`;
      });

      raf = requestAnimationFrame(animate);
    };

    window.addEventListener("pointermove", onPointerMove);
    raf = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener("pointermove", onPointerMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div ref={ref} className="tlx-repel-wordmark" aria-hidden="true">
      <div>{[..."TECHLYNX"].map((letter, i) => <span key={`${letter}-${i}`} data-letter>{letter}</span>)}</div>
      <small>INNOVATIONS PVT. LTD.</small>
    </div>
  );
}

export function TechlynxBrandEnd() {
  return (
    <section className="tlx-brand-transition" aria-label="Techlynx brand interaction">
      <div className="tlx-brand-grid" />
      <FloatingBubbles />
      <MarginFlowers />
      <div className="tlx-brand-side-lights" aria-hidden="true">
        {Array.from({ length: 10 }, (_, index) => <i key={index} />)}
      </div>
      <p>THE SYSTEM BEHIND THE SOLUTION</p>
      <RepelWordmark />
      <img className="tlx-brand-watermark" src="/banner.png" alt="" />
    </section>
  );

}

export default TechlynxHero;

/*import React, { useEffect, useRef } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import "../../styles/home/TechlynxHero.css";

const NODES = [
  [9, 15, "AI"], [22, 67, "DATA"], [33, 16, "CLOUD"], [43, 79, "DEV"],
  [55, 22, "WEB"], [66, 71, "SEC"], [78, 30, "ML"], [88, 62, "API"],
  [92, 18, "RAG"], [15, 48, "SQL"], [72, 84, "ERP"], [37, 51, "QA"],
];

function usePointerField(ref) {
  useEffect(() => {
    const root = ref.current;
    if (!root || window.matchMedia("(pointer: coarse)").matches) return undefined;

    let raf = 0;
    const target = { x: 0, y: 0, active: false };
    const current = { x: 0, y: 0 };

    const onMove = (event) => {
      const rect = root.getBoundingClientRect();
      target.x = event.clientX - rect.left;
      target.y = event.clientY - rect.top;
      target.active = true;
    };
    const onLeave = () => { target.active = false; };

    const tick = () => {
      current.x += ((target.active ? target.x : root.clientWidth * 0.52) - current.x) * 0.075;
      current.y += ((target.active ? target.y : root.clientHeight * 0.44) - current.y) * 0.075;
      root.style.setProperty("--mx", `${current.x}px`);
      root.style.setProperty("--my", `${current.y}px`);

      root.querySelectorAll("[data-depth]").forEach((el) => {
        const depth = Number(el.dataset.depth || 1);
        const dx = (current.x - root.clientWidth / 2) / root.clientWidth;
        const dy = (current.y - root.clientHeight / 2) / root.clientHeight;
        el.style.transform = `translate3d(${dx * depth * -28}px, ${dy * depth * -20}px, 0)`;
      });
      raf = requestAnimationFrame(tick);
    };

    root.addEventListener("pointermove", onMove);
    root.addEventListener("pointerleave", onLeave);
    raf = requestAnimationFrame(tick);
    return () => {
      root.removeEventListener("pointermove", onMove);
      root.removeEventListener("pointerleave", onLeave);
      cancelAnimationFrame(raf);
    };
  }, [ref]);
}

function HeroNetwork() {
  const ref = useRef(null);
  usePointerField(ref);

  return (
    <div ref={ref} className="tlx-hero-visual" aria-hidden="true">
      <div className="tlx-hero-vignette" />
      <div className="tlx-hero-grid" data-depth="1" />
      <div className="tlx-hero-scan" data-depth="2" />

      <div className="tlx-cursor-aura" />

      <div className="tlx-orbit tlx-orbit-a" data-depth="3" />
      <div className="tlx-orbit tlx-orbit-b" data-depth="2" />
      <div className="tlx-orbit tlx-orbit-c" data-depth="1" />

      <svg className="tlx-connections" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M11 25 L33 16 L55 22 L78 30 L92 18" />
        <path d="M15 48 L37 51 L55 22 L72 84" />
        <path d="M22 67 L37 51 L66 71 L88 62" />
        <path d="M43 79 L66 71 L72 84 L88 62" />
      </svg>

      {NODES.map(([x, y, label], index) => (
        <div
          key={label}
          className={`tlx-node tlx-node-${index}`}
          style={{ left: `${x}%`, top: `${y}%` }}
          data-depth={(index % 3) + 1}
        >
          <span />
          <small>{label}</small>
        </div>
      ))}

      <div className="tlx-core" data-depth="4">
        <div className="tlx-core-ring ring-one" />
        <div className="tlx-core-ring ring-two" />
        <div className="tlx-core-inner">
          <b>Techlynx</b>
          <span>Innovation<br />Pvt. Lmt</span>
        </div>
      </div>

      <div className="tlx-coordinate coord-a">17.492 / 82.231</div>
      <div className="tlx-coordinate coord-b">SYS.ONLINE // 98+</div>
    </div>
  );
}

function RepelWordmark() {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root || window.matchMedia("(pointer: coarse)").matches) return undefined;

    const letters = [...root.querySelectorAll("[data-letter]")];
    const pointer = { x: -1000, y: -1000 };
    const home = letters.map((el) => ({ el, x: 0, y: 0 }));
    let raf = 0;

    const move = (event) => { pointer.x = event.clientX; pointer.y = event.clientY; };
    const tick = () => {
      const rect = root.getBoundingClientRect();
      const cx = pointer.x;
      const cy = pointer.y;
      letters.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        const ex = r.left + r.width / 2;
        const ey = r.top + r.height / 2;
        const dx = ex - cx;
        const dy = ey - cy;
        const distance = Math.hypot(dx, dy);
        const radius = 185;
        let tx = 0;
        let ty = 0;
        if (distance < radius && distance > 0) {
          const strength = Math.pow((radius - distance) / radius, 2);
          tx = (dx / distance) * strength * 75;
          ty = (dy / distance) * strength * 75;
        }
        home[i].x += (tx - home[i].x) * 0.12;
        home[i].y += (ty - home[i].y) * 0.12;
        el.style.transform = `translate3d(${home[i].x}px, ${home[i].y}px, 0) rotate(${home[i].x * 0.025}deg)`;
      });
      root.style.setProperty("--brand-distance", `${Math.min(1, Math.hypot(cx - (rect.left + rect.width / 2), cy - (rect.top + rect.height / 2)) / 600)}`);
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener("pointermove", move);
    raf = requestAnimationFrame(tick);
    return () => { window.removeEventListener("pointermove", move); cancelAnimationFrame(raf); };
  }, []);

  return (
    <div ref={ref} className="tlx-repel-wordmark" aria-hidden="true">
      <div>{[..."TECHLYNX"].map((letter, i) => <span key={`${letter}-${i}`} data-letter>{letter}</span>)}</div>
      <small>INNOVATIONS PVT. LTD.</small>
    </div>
  );
}

export function TechlynxBrandEnd() {
  return (
    <section className="tlx-brand-transition" aria-label="Techlynx brand interaction">
      <div className="tlx-brand-grid" />
      <p>THE SYSTEM BEHIND THE SOLUTION</p>
      <RepelWordmark />
      <span className="tlx-brand-hint">TECHLYNX / INNOVATIONS</span><img className="tlx-brand-watermark" src="/banner.png" alt="" />
    </section>
  );
}

export default function TechlynxHero() {
  return (
    <section className="tlx-hero" id="home">
        <div className="tlx-hero-noise" /><div className="tlx-hero-stars" aria-hidden="true" /><img className="tlx-hero-banner" src="/banner.png" alt="" /><img className="tlx-hero-logo-watermark" src="/techlynx-icon.png" alt="" />
        
        <div className="tlx-hero-copy">
          <p className="tlx-hero-kicker"><i /> ONE TECHNOLOGY PARTNER</p>
          <h1>Build the<br /><em>future</em> with<br /><strong>intelligence</strong></h1>
          <p className="tlx-hero-description">Software. AI. Data. Cloud. Security. Automation. One connected technology ecosystem engineered around the way your business needs to move.</p>
          <div className="tlx-hero-actions">
            <a className="tlx-magnetic-button" href="#contact"><span>Start a project</span><FiArrowUpRight /></a>
            
          </div>
          <div className="tlx-hero-metrics" aria-label="Techlynx highlights">
            <div><strong>98+</strong><span>service domains</span></div>
            <div><strong>07</strong><span>technology pillars</span></div>
            <div><strong>01</strong><span>connected partner</span></div>
          </div>
        </div>

        <HeroNetwork />

        <div className="tlx-hero-footer">
          <span>98+ TECHNOLOGY &amp; PROFESSIONAL SERVICE DOMAINS</span>
          <span className="tlx-scroll-line"><i /> SCROLL TO ENTER</span>
          <span>SOFTWARE / AI / DATA / CLOUD</span>
        </div>
    </section>
  );
}*/
